/* Etiquetas multiidoma en inglés. */
export default {
  "availabilityCalendar.freeSale": "FS",
  "availabilityCalendar.weekDayShort.friday": "F",
  "availabilityCalendar.weekDayShort.monday": "M",
  "availabilityCalendar.weekDayShort.saturday": "S",
  "availabilityCalendar.weekDayShort.sunday": "U",
  "availabilityCalendar.weekDayShort.thursday": "R",
  "availabilityCalendar.weekDayShort.tuesday": "T",
  "availabilityCalendar.weekDayShort.wednesday": "W",
};
